module.exports = __webpack_public_path__ + "images/bug_light_blue_size_4_75fce1fb9ee942c247fc5f4994d18674.png";